/** OC head fields that can be flagged when they differ from the purchase order head. */
export type OcHeadComparisonFieldId =
  | 'supplier_order_number'
  | 'supplier_name'
  | 'supplier_contact_person'
  | 'payment_terms'
  | 'delivery_terms'
  | 'delivery_method'
  | 'invoice_address_company_name'
  | 'invoice_address_street'
  | 'invoice_address_house_number'
  | 'invoice_address_postal_code'
  | 'invoice_address_city'
  | 'invoice_address_country'
  | 'invoice_address_additional_information'
  | 'delivery_address_company_name'
  | 'delivery_address_street'
  | 'delivery_address_house_number'
  | 'delivery_address_postal_code'
  | 'delivery_address_city'
  | 'delivery_address_country'
  | 'delivery_address_additional_information'

export type OcHeadComparisonFlagFieldId =
  | 'flag_supplier_order_number'
  | 'flag_supplier_name'
  | 'flag_supplier_contact_person'
  | 'flag_payment_terms'
  | 'flag_delivery_terms'
  | 'flag_delivery_method'
  | 'flag_invoice_address_company_name'
  | 'flag_invoice_address_street'
  | 'flag_invoice_address_house_number'
  | 'flag_invoice_address_postal_code'
  | 'flag_invoice_address_city'
  | 'flag_invoice_address_country'
  | 'flag_invoice_address_additional_information'
  | 'flag_delivery_address_company_name'
  | 'flag_delivery_address_street'
  | 'flag_delivery_address_house_number'
  | 'flag_delivery_address_postal_code'
  | 'flag_delivery_address_city'
  | 'flag_delivery_address_country'
  | 'flag_delivery_address_additional_information'

export interface OcHeadComparisonField {
  id: OcHeadComparisonFieldId
  label: string
}

const OC_HEAD_FLAG_FIELD_MAP: Record<OcHeadComparisonFieldId, OcHeadComparisonFlagFieldId> = {
  supplier_order_number: 'flag_supplier_order_number',
  supplier_name: 'flag_supplier_name',
  supplier_contact_person: 'flag_supplier_contact_person',
  payment_terms: 'flag_payment_terms',
  delivery_terms: 'flag_delivery_terms',
  delivery_method: 'flag_delivery_method',
  invoice_address_company_name: 'flag_invoice_address_company_name',
  invoice_address_street: 'flag_invoice_address_street',
  invoice_address_house_number: 'flag_invoice_address_house_number',
  invoice_address_postal_code: 'flag_invoice_address_postal_code',
  invoice_address_city: 'flag_invoice_address_city',
  invoice_address_country: 'flag_invoice_address_country',
  invoice_address_additional_information: 'flag_invoice_address_additional_information',
  delivery_address_company_name: 'flag_delivery_address_company_name',
  delivery_address_street: 'flag_delivery_address_street',
  delivery_address_house_number: 'flag_delivery_address_house_number',
  delivery_address_postal_code: 'flag_delivery_address_postal_code',
  delivery_address_city: 'flag_delivery_address_city',
  delivery_address_country: 'flag_delivery_address_country',
  delivery_address_additional_information: 'flag_delivery_address_additional_information',
}

export function toFlagFieldId(fieldId: OcHeadComparisonFieldId): OcHeadComparisonFlagFieldId {
  return OC_HEAD_FLAG_FIELD_MAP[fieldId]
}

const OC_HEAD_GENERAL_FIELDS: OcHeadComparisonField[] = [
  { id: 'supplier_order_number', label: 'Supplier order number' },
  { id: 'supplier_name', label: 'Supplier name' },
  { id: 'supplier_contact_person', label: 'Supplier contact person' },
  { id: 'payment_terms', label: 'Payment terms' },
  { id: 'delivery_terms', label: 'Delivery terms' },
  { id: 'delivery_method', label: 'Delivery method' },
]

const OC_HEAD_INVOICE_ADDRESS_FIELDS: OcHeadComparisonField[] = [
  { id: 'invoice_address_company_name', label: 'Company' },
  { id: 'invoice_address_street', label: 'Street' },
  { id: 'invoice_address_house_number', label: 'House number' },
  { id: 'invoice_address_postal_code', label: 'Postal code' },
  { id: 'invoice_address_city', label: 'City' },
  { id: 'invoice_address_country', label: 'Country' },
  { id: 'invoice_address_additional_information', label: 'Additional info' },
]

const OC_HEAD_DELIVERY_ADDRESS_FIELDS: OcHeadComparisonField[] = [
  { id: 'delivery_address_company_name', label: 'Company' },
  { id: 'delivery_address_street', label: 'Street' },
  { id: 'delivery_address_house_number', label: 'House number' },
  { id: 'delivery_address_postal_code', label: 'Postal code' },
  { id: 'delivery_address_city', label: 'City' },
  { id: 'delivery_address_country', label: 'Country' },
  { id: 'delivery_address_additional_information', label: 'Additional info' },
]

export const OC_HEAD_COMPARISON_FIELDS: OcHeadComparisonField[] = [
  ...OC_HEAD_GENERAL_FIELDS,
  ...OC_HEAD_INVOICE_ADDRESS_FIELDS,
  ...OC_HEAD_DELIVERY_ADDRESS_FIELDS,
]

export { OC_HEAD_GENERAL_FIELDS, OC_HEAD_INVOICE_ADDRESS_FIELDS, OC_HEAD_DELIVERY_ADDRESS_FIELDS }

export const DEFAULT_FLAGGED_OC_HEAD_FIELDS: OcHeadComparisonFieldId[] = [
  'payment_terms',
  'delivery_terms',
]
